import React from 'react';

/**
 * Lightweight background motif for the hero. Pure CSS (transform/opacity
 * keyframes defined in styles.css), no canvas, no requestAnimationFrame,
 * no per-frame JS — runs entirely on the compositor thread.
 */
const TechGrid = () => (
  <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
    <div className="tech-grid-layer" />
    <div
      className="tech-grid-glow absolute left-1/2 top-1/3 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full"
      style={{
        background: 'radial-gradient(circle, rgba(110,91,255,0.22) 0%, rgba(110,91,255,0) 70%)',
      }}
    />
  </div>
);

export default TechGrid;
